import dynamic from 'next/dynamic';

const esadirComponents = {
    ArbreNavegacio: { dynamicComponent: dynamic(() => import(`components/esadir/ArbreNavegacio`)) },
    Capcalera: { dynamicComponent: dynamic(() => import(`components/corporatiu/Menu`)) },
    Cercador: { dynamicComponent: dynamic(() => import(`components/esadir/Cercador`)) },
    Columna: { dynamicComponent: dynamic(() => import(`components/corporatiu/Columna`)) },
    Compartir: { dynamicComponent: dynamic(() => import(`components/esadir/Compartir`)) },
    Contenidor: { dynamicComponent: dynamic(() => import(`components/corporatiu/Contenidor`)) },
    ContingutEstatic: { dynamicComponent: dynamic(() => import(`components/esadir/ContingutEstatic`)) },
    ContingutsMovil: { dynamicComponent: dynamic(() => import(`components/esadir/ContingutsMovil`)) },
    DadesNomPropi: { dynamicComponent: dynamic(() => import(`components/esadir/DadesNomPropi`)) },
    Enllac: { dynamicComponent: dynamic(() => import(`components/corporatiu/Enllac`)) },
    EtiquetesToponim: { dynamicComponent: dynamic(() => import(`components/esadir/EtiquetesToponim`)) },
    Fila: { dynamicComponent: dynamic(() => import(`components/corporatiu/Fila`)) },
    FilAriadna: { dynamicComponent: dynamic(() => import(`components/esadir/FilAriadna`)) },
    FitxaPellicula: { dynamicComponent: dynamic(() => import(`components/esadir/FitxaPellicula`)) },
    Header: { dynamicComponent: dynamic(() => import(`components/esadir/Header`)) },
    Imatge: { dynamicComponent: dynamic(() => import(`components/esadir/Imatge`)) },
    InfoFilmoteca: { dynamicComponent: dynamic(() => import(`components/esadir/InfoFilmoteca`)) },
    ItemMock: { dynamicComponent: dynamic(() => import(`components/esadir/ItemMock`)) },
    LlistaAnysFilmoteca: { dynamicComponent: dynamic(() => import(`components/esadir/LlistaAnysFilmoteca`)) },
    LlistaEnllacos: { dynamicComponent: dynamic(() => import(`components/esadir/LlistaEnllacos`)) },
    LlistaSeccio: { dynamicComponent: dynamic(() => import(`components/esadir/LlistaSeccio`)) },
    LlistaSeccioAleatoria: { dynamicComponent: dynamic(() => import(`components/esadir/LlistaSeccioAleatoria`)) },
    Paginador: {dynamicComponent: dynamic(() => import(`components/esadir/Paginador`))},
    ResultatsCercaEsadir: { dynamicComponent: dynamic(() => import(`components/esadir/ResultatsCercaEsadir`)) },
    ResultatsNomsPropis: { dynamicComponent: dynamic(() => import(`components/esadir/ResultatsNomsPropis`)) },
    ResultatsCercaPellicules: { dynamicComponent: dynamic(() => import(`components/esadir/ResultatsCercaPellicules`)) },
    Menu: { dynamicComponent: dynamic(() => import(`components/esadir/Menu`)) },
    Pellicules: { dynamicComponent: dynamic(() => import(`components/esadir/Pellicules`)) },
    Metadades: { dynamicComponent: dynamic(() => import(`components/esadir/Metadades`)) },
    Peu: { dynamicComponent: dynamic(() => import(`components/corporatiu/Peu`)) },
    PeuEsadir: { dynamicComponent: dynamic(() => import(`components/esadir/PeuEsadir`)) },
    Subtitol: { dynamicComponent: dynamic(() => import(`components/esadir/Subtitol`)) },
    Text: { dynamicComponent: dynamic(() => import(`components/esadir/Text`)) },
    Titol: { dynamicComponent: dynamic(() => import(`components/corporatiu/Titol`)) },
    TitolAmbSo: { dynamicComponent: dynamic(() => import(`components/esadir/TitolAmbSo`)) },
    
};

export { esadirComponents };
